import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@chakra-ui/react";
import { fetchAnalystList } from "services/serviceUtils";
import { HeaderWithStats } from "services/MetadataServices";
import AnalystList from "../../modules/analyst/containers/AnalystList";
import { useUIContext } from "context/UIContext";

const AnalystListPage: React.FC = () => {
  const navigate = useNavigate();
  const { setIsNavbarCollapsed } = useUIContext();

  const [analystHeaders, setAnalystHeaders] = useState<HeaderWithStats[]>([]);
  // Phase 1: loading the card list (no stats) — shows a full-page spinner.
  const [isLoading, setIsLoading] = useState(true);
  // Phase 2: loading stats to hydrate each card — shows per-card stat spinners.
  const [isLoadingStats, setIsLoadingStats] = useState(true);

  useEffect(() => {
    const load = async () => {
      // Phase 1 — fast: fetch headers without stats so cards render immediately.
      setIsLoading(true);
      setIsLoadingStats(true);
      const cards = await fetchAnalystList(false);
      setAnalystHeaders(cards);
      setIsLoading(false);

      // Phase 2 — slower: fetch headers with stats and merge them in.
      const withStats = await fetchAnalystList(true);
      setAnalystHeaders(withStats);
      setIsLoadingStats(false);
    };
    load();
  }, []);

  const handleAnalystSelection = (header: HeaderWithStats) => {
    if (!header.id) return;
    setIsNavbarCollapsed(true);
    navigate(`/analyst/${header.id}`);
  };

  const handleCreateNewAnalyst = () => {
    navigate("/analyst/new");
  };

  return (
    <Box width="100%" height="100vh" bg="gray.50">
      {/* Analyst list container */}
      <AnalystList
        analystHeaders={analystHeaders}
        setAnalystHeaders={setAnalystHeaders}
        onAnalystSelection={handleAnalystSelection}
        onCreateNewAnalyst={handleCreateNewAnalyst}
        isLoading={isLoading}
        isLoadingStats={isLoadingStats}
      />
    </Box>
  );
};

export default AnalystListPage;
